import React, { useMemo } from "react";
import {Link} from "react-router-dom";
import BgIcon from "./BgIcon";
import "./landing.css";

const Landing =  ()=>{
    const nbrOfIcons = Math.ceil(window.innerWidth/100)<10?10:Math.ceil(window.innerWidth/100);
    const Icons = useMemo(()=>Array(nbrOfIcons).fill(0).map((_,i)=><BgIcon key={i} index={i}/>),[])

    return <div id="landing-page">
        {Icons}
        <div className="image">
            <img src="/dark.png" width="100%" height="auto" alt="landing"/>
        </div>
        <div className="text">
            <h1>بغيتي تشد لبرمي؟</h1>
            <h2>
                <div>قرب ليك الإمتحان ومازال ماموجد والو؟ </div>
                <div> هده هي <span> أحسن بلاصة للإستعداد</span></div>
                <div>ليوم إمتحان الكود.</div>
            </h2>
            <span className="buttons">

        <Link 
            to={"serie/test/question/1"} 
            onClick={()=>{
                sessionStorage.setItem("__users_answers__", JSON.stringify([]));
            }}
            className="btn" 
        >{`جرب الآن`}</Link>
        <Link to="/login" className="btn">تسجيل</Link>
            </span>
        </div>
    </div>
}

export default Landing;